import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ManualCalibrationPopoverProps {
  customDistanceInput: string;
  validationError: string | null;
  onCustomDistanceInputChange: (value: string) => void;
  onApply: () => void;
  onCancel: () => void;
}

export function ManualCalibrationPopover({
  customDistanceInput,
  validationError,
  onCustomDistanceInputChange,
  onApply,
  onCancel,
}: ManualCalibrationPopoverProps) {
  return (
    <div className="pointer-events-auto w-48 rounded-lg border bg-background/95 p-3 shadow-xl backdrop-blur">
      <div className="mb-2 text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">
        Calibrate
      </div>
      <input
        aria-label="Calibration distance"
        placeholder={'10\'-6"'}
        value={customDistanceInput}
        onChange={(event) => onCustomDistanceInputChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            onApply();
          }
        }}
        className={cn(
          "mb-2 h-8 w-full rounded border border-border bg-background px-2 text-sm",
          validationError ? "border-red-500" : ""
        )}
        autoFocus
      />
      <div className="flex gap-2">
        <Button size="sm" className="h-8 flex-1" onClick={onApply}>
          Apply
        </Button>
        <Button size="sm" variant="ghost" className="h-8" onClick={onCancel}>
          Cancel
        </Button>
      </div>
      {validationError ? (
        <div className="mt-2 text-[11px] leading-tight text-red-500">
          {validationError}
        </div>
      ) : null}
    </div>
  );
}
